import { DataService } from '../../../shared/dataservice.service';
import { Component, OnInit, Input } from '@angular/core';
import { SalesOrder, SubSalesOrder, SOStatus, SSOStatus, monthFilter, PmTechnicalIP,  UiFunctionalKPI } from '../../../shared/misc-classes';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { KPIChartService } from '../../../shared/kpi-charts-service';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-production-kpi',
  templateUrl: './production-kpi.component.html',
  styleUrls: ['./production-kpi.component.css']
})
export class ProductionKpiComponent implements OnInit {

  @Input() pmTechSSO: PmTechnicalIP;
  soObj: SalesOrder;
  _soObjListKpi7: Array<SalesOrder>;

  filteredSOCount: number = 0;
  filteredSSOCount: number = 0;
  isDataViewUpdated4: boolean = false;
  isLoading: boolean = false;
  ProdKpi: Array<UiFunctionalKPI> = [];


  isManfMonthFilterSelectedKpi7: boolean = false;
  manfMonthFilterKpi7: monthFilter;

  Highcharts = Highcharts;

  totalDataACT: any;
  totalDataKpiChartOptionsACT: Highcharts.Options;
  panelWiseDataACT: any;
  panelWiseKpiChartOptionsACT: Highcharts.Options;

  totalDataMECH: any;
  totalDataKpiChartOptionsMECH: Highcharts.Options;
  panelWiseDataMECH: any;
  panelWiseKpiChartOptionsMECH: Highcharts.Options;

  
  constructor(public _dataService: DataService, public dialog: MatDialog,
    private _kpiCharServ: KPIChartService) { }

  ngOnInit() {
    try {
      this.loadSettingsFromCookies();
    } catch (e) {
      console.log(e);
    }

    this.loadData();
  }
  saveSettingsToCookies() {
    this._dataService.setCookie('s-manfmonth-sel-kpi-8', this.isManfMonthFilterSelectedKpi7 ? "1" : "0");
    if (this.isManfMonthFilterSelectedKpi7) {
      this._dataService.setCookie('s-manfmonth-val-kpi-8', this.manfMonthFilterKpi7.getCookieStr());
    }
  }
  loadSettingsFromCookies() {


    let _tmpManfMonthSel: string = this._dataService.getCookie('s-manfmonth-sel-kpi-8');
    if (_tmpManfMonthSel) {
      this.isManfMonthFilterSelectedKpi7 = (_tmpManfMonthSel == "1");

      let _tmpManfMonthVal: string = this._dataService.getCookie('s-manfmonth-val-kpi-8');
      if (_tmpManfMonthVal) {
        this.manfMonthFilterKpi7 = monthFilter.getObjFromCookieStr(_tmpManfMonthVal);
      }
    }


    let _currDate: Date = new Date();
    if (this.manfMonthFilterKpi7 == null) {
      this.manfMonthFilterKpi7 = new monthFilter(_currDate.getMonth() + 1, _currDate.getFullYear(),
        _currDate.getMonth() + 1, _currDate.getFullYear());
    }

  }
  loadData() {
    this.isLoading = true;
    this._dataService.getDataDefinitions().subscribe(res => {
      this._dataService.getAllSalesOrder(1).subscribe((_soObjAr: Array<SalesOrder>) => {
        this._soObjListKpi7 = _soObjAr.filter((_tmpSO2: SalesOrder) => {
          //test the filter.
          // if(_tmpSO2.projectStatus == SOStatus.Dispatched || _tmpSO2.projectStatus == SOStatus.Archived)
          if (_tmpSO2.projectStatus == SOStatus.Dispatched) {
            return false;
          }
          return true;
        });
        this.filterRows();
      });
    });
  }

  getClassName(_temp: number): string {
    if (_temp < 6) {
      return "bg-grey";
    } else if (_temp >= 6 && _temp < 10) {
      return "bg-yellow";
    } else if (_temp > 10) {
      return "bg-green";
    }
  }



  reloadData(): void {
    this.isLoading = true;
    this.loadData();
  }
  clearFilters(): void {

    this.isManfMonthFilterSelectedKpi7 = false;
    this.isLoading = true;
    this.loadData();

    setTimeout(() => {
      this.saveSettingsToCookies();
    }, 10);
  }



  filterRows(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.filterRowsLogic2();
      this.isLoading = false;
    }, 5);
    this.saveSettingsToCookies();
  }


  private displaySOwithNoSSO() {
    if (this.isManfMonthFilterSelectedKpi7 == true

    ) {
      return false;
    }

    return true;
  }


  filterRowsLogic2() {
    let _tmpSOCounter: number = 0;
    let _tmpSSOCounter: number = 0;
    let _tmpProdKpi: Array<UiFunctionalKPI> = [];

    let _totalQtyACT: number = 0;
    let _delayQtyACT: number = 0;
    let _onTimeQtyACT: number = 0;
    let _delayQtyACTZS1: number = 0;
    let _onTimeQtyACTZS1: number = 0;
    let _delayQtyACTZS1DBB: number = 0;
    let _onTimeQtyACTZS1DBB: number = 0;
    let _delayQtyACTZS2: number = 0;
    let _onTimeQtyACTZS2: number = 0;
    let _delayQtyACTZS9: number = 0;
    let _onTimeQtyACTZS9: number = 0;
    let _delayQtyACTZN1: number = 0;
    let _onTimeQtyACTZN1: number = 0;

    let _totalQtyMECH: number = 0;
    let _delayQtyMECH: number = 0;
    let _onTimeQtyMECH: number = 0;
    let _delayQtyMECHZS1: number = 0;
    let _onTimeQtyMECHZS1: number = 0;
    let _delayQtyMECHZS1DBB: number = 0;
    let _onTimeQtyMECHZS1DBB: number = 0;
    let _delayQtyMECHZS2: number = 0;
    let _onTimeQtyMECHZS2: number = 0;
    let _delayQtyMECHZS9: number = 0;
    let _onTimeQtyMECHZS9: number = 0;
    let _delayQtyMECHZN1: number = 0;
    let _onTimeQtyMECHZN1: number = 0;

   

    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

    let _showSOWithNoSSO: boolean = this.displaySOwithNoSSO();

    for (var i = 0; i < this._soObjListKpi7.length; i++) {
      let _tmpSO: SalesOrder = this._soObjListKpi7[i];

      let _isSOPassedFilter: boolean = true;
      if (_isSOPassedFilter == true) {
        let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrders(_tmpSO.subSalesOrder);

        if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {

          let _tmpSSOobj: UiFunctionalKPI;

          _tmpSOCounter++;

          _filteredSSO.forEach((_tmpSSO: SubSalesOrder) => {

            

            // Check for Actual line loading planned and Actual Dates      

            if (_tmpSSO.productionIP.lineLoadingActualDate != null) {
              let _actualActual = _tmpSSO.productionIP.lineLoadingActualDate.getTime();
              let _isRevised = null;
              let _isRequested;
              let _actualOtherDate;
              if( _tmpSSO.productionIP.requestedLineLoadingDate==null){
                _isRequested = false;
                _actualOtherDate = _tmpSSO.planningIP.plannedLineLoadingDate.getTime();
                _isRevised = _tmpSSO.planningIP.plannedLineLoadingDateIsRevised;
            }
            else{
              _isRequested = true;
              _actualOtherDate = _tmpSSO.planningIP.requestedLineLoadingDate.getTime();
            }
            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtyACT += temp;
                  
                  
                }
              }
            });
              let _actualDiff_time =  _actualOtherDate - _actualActual;
              let _actualDiff = _actualDiff_time / (1000 * 3600 * 24);
              ///Actual line loading Finalization Delay
              if (_actualDiff < 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtyACT += temp;
                    }
                  }
                });

                let _individualDelayQtyAct = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyACTZS1 += temp;
                          _individualDelayQtyAct += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyACTZS1DBB += temp;
                          _individualDelayQtyAct += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyACTZS2 += temp;
                          _individualDelayQtyAct += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyACTZN1 += temp;
                          _individualDelayQtyAct += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyACTZS9 += temp;
                          _individualDelayQtyAct += temp;
                        }
                      }
                    });
                    break;
                }

                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.planningIP.plannedLineLoadingDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.planningIP.plannedLineLoadingDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp = _isRequested==false?null:_tmpSSO.productionIP.requestedLineLoadingDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'Actual line loading',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtyAct, _plannedTmp, _revisedTmp,
                _requestedTmp, _tmpSSO.productionIP.lineLoadingActualDate, _actualDiff, _tmpSSO.productionIP.lineLoadingActualToken.addNotes)
                
                _tmpProdKpi.push(_tmpSSOobj);
              }
              // Actual Line Loading Finalization on Time
              if (_actualDiff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtyACT += temp;
                    }
                  }
                });

                let _individualOnTimeQtyAct = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyACTZS1 += temp;
                          _individualOnTimeQtyAct += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyACTZS1DBB += temp;
                          _individualOnTimeQtyAct += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyACTZS2 += temp;
                          _individualOnTimeQtyAct += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyACTZN1 += temp;
                          _individualOnTimeQtyAct += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyACTZS9 += temp;
                          _individualOnTimeQtyAct += temp;
                        }
                      }
                    });
                    break;
                }

                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.planningIP.plannedLineLoadingDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.planningIP.plannedLineLoadingDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp = _isRequested==false?null:_tmpSSO.productionIP.requestedLineLoadingDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'Actual line loading',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtyAct, _plannedTmp, _revisedTmp,
                _requestedTmp, _tmpSSO.productionIP.lineLoadingActualDate, _actualDiff, _tmpSSO.productionIP.lineLoadingActualToken.addNotes)
               
                    _tmpProdKpi.push(_tmpSSOobj);
              }     


            }

            // Check for Mechanical Sticker Planned and Actual Dates

            if (_tmpSSO.productionIP.mechanicalStickerActualDate != null) {
              let _mechActual = _tmpSSO.productionIP.mechanicalStickerActualDate.getTime();
              let _isRevised = null;
              let _isRequested;
              let _mechOtherDate;
              if( _tmpSSO.productionIP.mechanicalStickerRequestedDate==null){
                _isRequested = false;
                _mechOtherDate = _tmpSSO.productionIP.mechanicalStickerPlannedDate.getTime();
                _isRevised = _tmpSSO.productionIP.mechanicalStickerPlannedDateIsRevised;
            }
            else{
              _isRequested = true;
              _mechOtherDate = _tmpSSO.productionIP.mechanicalStickerRequestedDate.getTime();
            }
            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtyMECH += temp;
                  
                  
                }
              }
            });
              let _mechDiff_time =  _mechOtherDate - _mechActual;
              let _mechDiff = _mechDiff_time / (1000 * 3600 * 24);
              ///Mechanical Sticker Finalization Delay
              if (_mechDiff < 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtyMECH += temp;
                    }
                  }
                });

                let _individualDelayQtyMech = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMECHZS1 += temp;
                          _individualDelayQtyMech += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMECHZS1DBB += temp;
                          _individualDelayQtyMech += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMECHZS2 += temp;
                          _individualDelayQtyMech += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMECHZN1 += temp;
                          _individualDelayQtyMech += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMECHZS9 += temp;
                          _individualDelayQtyMech += temp;
                        }
                      }
                    });
                    break;
                }
                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.productionIP.mechanicalStickerPlannedDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.productionIP.mechanicalStickerPlannedDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp = _isRequested==false?null:_tmpSSO.productionIP.mechanicalStickerRequestedDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'Mechanical sticker',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtyMech, _plannedTmp, _revisedTmp,
                  _requestedTmp, _tmpSSO.productionIP.mechanicalStickerActualDate, _mechDiff,_tmpSSO.productionIP.mechanicalStickerActualToken.addNotes)
                
                  _tmpProdKpi.push(_tmpSSOobj);
              }
              // Mechanical Finalization on Time
              if (_mechDiff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtyMECH += temp;
                    }
                  }
                });

                let _individualOnTimeQtyMech = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMECHZS1 += temp;
                          _individualOnTimeQtyMech += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMECHZS1DBB += temp;
                          _individualOnTimeQtyMech += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMECHZS2 += temp;
                          _individualOnTimeQtyMech += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMECHZN1 += temp;
                          _individualOnTimeQtyMech += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMECHZS9 += temp;
                          _individualOnTimeQtyMech += temp;
                        }
                      }
                    });
                    break;
                }
                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.productionIP.mechanicalStickerPlannedDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.productionIP.mechanicalStickerPlannedDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp = _isRequested==false?null:_tmpSSO.productionIP.mechanicalStickerRequestedDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'Mechanical sticker',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtyMech, _plannedTmp, _revisedTmp,
                  _requestedTmp, _tmpSSO.productionIP.mechanicalStickerActualDate, _mechDiff,_tmpSSO.productionIP.mechanicalStickerActualToken.addNotes)

                _tmpProdKpi.push(_tmpSSOobj);
              }     


            }

          });

        }


      }

    }

    if (_totalQtyACT != 0 || _onTimeQtyACT != 0 || _delayQtyACT != 0) {
      this.totalDataACT = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtyACT,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtyACT,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtyACT,
        }]
      }

      ];
    }
    else { this.totalDataACT = null; }

    this.totalDataKpiChartOptionsACT = this._kpiCharServ.getTotalDataChartOptions(this.totalDataACT);

    if (_onTimeQtyACTZN1 != 0 || _onTimeQtyACTZS9 != 0 || _onTimeQtyACTZS1 != 0 || _onTimeQtyACTZS1DBB != 0 || _onTimeQtyACTZS2 != 0
      || _delayQtyACTZN1 != 0 || _delayQtyACTZS9 != 0 || _delayQtyACTZS1 != 0 || _delayQtyACTZS1DBB != 0 || _delayQtyACTZS2 != 0) {

      this.panelWiseDataACT = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtyACTZN1, _onTimeQtyACTZS9, _onTimeQtyACTZS1, _onTimeQtyACTZS1DBB, _onTimeQtyACTZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtyACTZN1, _delayQtyACTZS9, _delayQtyACTZS1, _delayQtyACTZS1DBB, _delayQtyACTZS2],
      }

      ];
    }
    else { this.panelWiseDataACT = null; }

    this.panelWiseKpiChartOptionsACT = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataACT);


    ////

    if (_totalQtyMECH != 0 || _onTimeQtyMECH != 0 || _delayQtyMECH != 0) {
      this.totalDataMECH = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtyMECH,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtyMECH,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtyMECH,
        }]
      }

      ];
    }
    else { this.totalDataMECH = null; }

    this.totalDataKpiChartOptionsMECH = this._kpiCharServ.getTotalDataChartOptions(this.totalDataMECH);

    if (_onTimeQtyMECHZN1 != 0 || _onTimeQtyMECHZS9 != 0 || _onTimeQtyMECHZS1 != 0 || _onTimeQtyMECHZS1DBB != 0 || _onTimeQtyMECHZS2 != 0
      || _delayQtyMECHZN1 != 0 || _delayQtyMECHZS9 != 0 || _delayQtyMECHZS1 != 0 || _delayQtyMECHZS1DBB != 0 || _delayQtyMECHZS2 != 0) {

      this.panelWiseDataMECH = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtyMECHZN1, _onTimeQtyMECHZS9, _onTimeQtyMECHZS1, _onTimeQtyMECHZS1DBB, _onTimeQtyMECHZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtyMECHZN1, _delayQtyMECHZS9, _delayQtyMECHZS1, _delayQtyMECHZS1DBB, _delayQtyMECHZS2],
      }

      ];
    }
    else { this.panelWiseDataMECH = null; }

    this.panelWiseKpiChartOptionsMECH = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataMECH);



    

    this.filteredSOCount = _tmpSOCounter;
    this.filteredSSOCount = _tmpSSOCounter;
    this.ProdKpi = _tmpProdKpi;


    this.isDataViewUpdated4 = true;
    setTimeout(() => {
      this.isDataViewUpdated4 = false;
    }, 1000);
  }


  getManfMonthLabel(): string {
    if (this.isManfMonthFilterSelectedKpi7 == true) {
      return "Manufacturing Month : ";
    }
    else {
      return "Enable Manufacturing Month Filter";
    }
  }

  getManfFromMonthName(): string {
    if (this.manfMonthFilterKpi7) {
      return this.manfMonthFilterKpi7.fromMonthName;
    }
    return '';
  }
  getManfToMonthName(): string {
    if (this.manfMonthFilterKpi7) {
      return this.manfMonthFilterKpi7.toMonthName;
    }
    return '';
  }

  manfPrevFromMonth() {
    this.manfMonthFilterKpi7.prevFromMonth();
    this.filterRows();
  }
  manfNextFromMonth() {
    this.manfMonthFilterKpi7.nextFromMonth();
    this.filterRows();
  }
  manfPrevToMonth() {
    this.manfMonthFilterKpi7.prevToMonth();
    this.filterRows();
  }
  manfNextToMonth() {
    this.manfMonthFilterKpi7.nextToMonth();
    this.filterRows();
  }

  private getFilteredSubOrders(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      //check for failure cases
      //dont show if sub order is dispatched
      if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true) return false;

      //check if mfg month 
      if (this.isManfMonthFilterPassed(_sso.manufacturingMonth) == false) return false;
      return true;
    });
  }


  private isManfMonthFilterPassed(_manfMonth: Date) {
    if (this.isManfMonthFilterSelectedKpi7 == true && this.manfMonthFilterKpi7 != null) {
      if (this.manfMonthFilterKpi7.isWithInFilterScope(_manfMonth) == false) {
        return false;
      }
    }
    return true;
  }

}
